import React, { useState, useRef } from "react";
import { Input, UploadingInput, SideSVG } from "../../../common";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as Close } from "../../../../assets/icons/close-circle.svg";
import { ReactComponent as LetterSVG } from "../../../../assets/images/signUp/letter.svg";
import DownloadButton from "../../../common/DownloadButton";
import { useUpdateAuthorizedSignMutation, useCreateCompanyMutation, useIndustryMutation, useIndividualCompanyMutation, useCreateAddressDetailsMutation, useCreateAddressMutation, useAuthorizedSignMutation, useCreateAuthorizedSignMutation } from "../../../../store/Company/companyApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { setAuthorizedSignatory } from "../../../../store/Company/companySlice";
import { useGetClaimedMutation } from "../../../../store/Company/companyApiSlice";
import Logo from "../../Logo";
import { uploadFilePath } from "../../../../constants/s3UploadPath";
import { uploadFileToS3 } from "../../../../utils/uploadFileToS3";
import { CommonToast } from "../../../common/Toast";
import { clearUserInfo } from "../../../../store/auth/authSlice";
import { useNavigate } from "react-router-dom";

export const AuthorizedLetter = ({ onNext, onPrev }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [progress, setProgress] = useState(5);
  const [apiError, setApiError] = useState("");
  const [clickedNext, setclickedNext] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);

  const { individualID } = useSelector((state) => state.auth);
  const { authorizedSignatory, currentEditingCompany } = useSelector(
    (state) => state.company
  );
  const { token, userInfo } = useSelector((state) => state.auth);
  const [updateAuthorizedSign, { isLoading }] =
    useUpdateAuthorizedSignMutation();

  const [GetClaimed, { isLoading: GetMuatation }] = useGetClaimedMutation();

  const [RequestType, setRequestType] = useState("");
  const [status, setstatus] = useState("");
  const [companyID, setcompanyID] = useState("");

  const pdfLink = `${process.env.PUBLIC_URL}/documents/Letter_of_Authorization%20_TREVEX.pdf`;
  const filename = "Letter_of_Authorization _TREVEX.pdf";
  const [createCompany, { isLoading: companyCreating }] = useCreateCompanyMutation();
  const [industry] = useIndustryMutation();
  const [createAddressDetails] = useCreateAddressDetailsMutation();
  const [setAddressConnection] = useCreateAddressMutation();
  const [authorizedSignCreate] = useAuthorizedSignMutation();
  const [createAuthorizedSignConnection] = useCreateAuthorizedSignMutation();
  const [individualCompany] = useIndividualCompanyMutation();

  const handleFileSelect = (file) => {
    setUploadedFile(file);
    if (file && file.type.match("image.*")) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };

      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
    }
  };

  const companyDataString = localStorage.getItem("createCompany");
  const companyData = JSON.parse(JSON.stringify(companyDataString));
  let claimComapnyID = localStorage.getItem("claimComapnyID");
  const createCompanyID = companyData?.companyID;
  const companyDataCurrent = localStorage.getItem("companyData");
  const companyCurrentData = JSON.parse(companyDataCurrent);
  const handleSubmit = async (e) => {
    setApiLoading(true)
    if (!token) {
      CommonToast.error("Token is required");
      dispatch(clearUserInfo());
      navigate('/login');
      throw new Error("Token is required")
    }
    setclickedNext(true);
    e.preventDefault();
    const errors = {};
    if (!uploadedFile) {
      errors.tradePhotoError =
        "Please upload your authorization letter photo or pdf.";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      let filledcompany = JSON.parse(localStorage.getItem("filledcompany"));
      let userSelectedCompany = JSON.parse(localStorage.getItem("userSelectedCompany"));
      let claimAuthSignDetails = JSON.parse(localStorage.getItem("claimAuthSignDetails"));
      let claimContactDetails = JSON.parse(localStorage.getItem("claimContactDetails"));
      let claimTradeLicenceDetails = JSON.parse(localStorage.getItem("claimTradeLicenceDetails"));
      let industryDetails = JSON.parse(localStorage.getItem("industryDetails"));
      let claimAddressDetails = JSON.parse(localStorage.getItem("claimAddressDetails"));
      try {
        const authLettersUrl = await uploadFileToS3(
          uploadFilePath?.authLetters,
          uploadedFile,
          token,
          currentEditingCompany?.companyID
        );
        if (authLettersUrl?.url) {
          const { data: companyData, status: companyStatus } = await createCompany({
            data: {
              registered_company_name: filledcompany ? filledcompany.registered_company_name : (userSelectedCompany?.data?.registered_company_name || userSelectedCompany?.registered_company_name),
              wb_win: filledcompany ? filledcompany?.wb_win : (userSelectedCompany?.data?.wb_win || userSelectedCompany?.wb_win),
              country_code: filledcompany ? filledcompany?.country_code : (userSelectedCompany?.data?.country_code || userSelectedCompany?.country_code),
              new_company: filledcompany ? filledcompany?.new_company : (userSelectedCompany?.data?.new_company || userSelectedCompany?.new_company),
              is_claimed:1, // this is_claimed flag, added tempororyly for duplicate secondary company issue, this flag will default 0 when created due to relation, 1 if someone claimed that company but not verified, after verified by admin we will change it 2
              trade_license: claimTradeLicenceDetails.trade_license,
              license_no: claimTradeLicenceDetails.license_no,
            },
            token,
          }).unwrap();
          const jsonData = JSON.stringify(companyData);
          localStorage.setItem("createCompany", jsonData);

          if (companyStatus === 201) {
            const res = await industry({
              data: {
                sector: industryDetails.sector,
                industry_group: industryDetails.industry_group,
                industry: industryDetails.industry,
                sub_industry: industryDetails.sub_industry,
                companyID: companyData.companyID,
              },
              token,
            }).unwrap();
            const resAddress = await createAddressDetails({
              data: {
                address_line_1: claimAddressDetails.address_line_1,
                address_line_2: claimAddressDetails.address_line_2,
                postal_code: claimAddressDetails.postal_code,
                area: claimAddressDetails.area,
                city: claimAddressDetails.city,
                state: claimAddressDetails.state,
                country: claimAddressDetails.country,
                working_hours: claimAddressDetails.working_hours,
                telephone: claimContactDetails.telephone,
                email: claimContactDetails.email,
              },
              token,
            }).unwrap();

            if (resAddress) {
              const addressData = await setAddressConnection({
                data: {
                  primary_address: true,
                  company_address_detailsID: resAddress.company_address_detailsID,
                  companyID: companyData.companyID,
                },
                token,
                companyId: companyData.companyID,
              }).unwrap();
            }
            const resAuth = await authorizedSignCreate({
              data: {
                name: claimAuthSignDetails.name,
                designation: claimAuthSignDetails.designation,
                work_email: claimAuthSignDetails.work_email,
                work_mobile: claimAuthSignDetails.work_mobile,
                nationality: claimAuthSignDetails.nationality,
                auth_letter_upload: authLettersUrl?.url
              },
              token,
            }).unwrap();
            if (resAuth) {
              const companyAuthSinged = await createAuthorizedSignConnection({
                data: {
                  Authorized_signID: resAuth?.authorized_signID,
                  companyID: companyData?.companyID,
                },
                token,
              }).unwrap();
            }

          }
          setProgress(60);
          if (companyData === undefined) {
            throw new Error("You are not authorized to access this page.");
          }
          if (companyData) {
            const handleGetClaimed = async () => {
              try {
                const resp = await GetClaimed({
                  data: {
                    new_company: companyData
                      ? companyData?.new_company
                      : companyCurrentData?.new_company,
                    request_type: "Claim Company",
                    adminID: 1,
                    companyID: companyData?.companyID,
                    companyName: companyData?.registered_company_name,
                    individualID: userInfo?.individual[0]?.individualID,
                  },
                  token,
                }).unwrap();
                if (resp) {
                  let createindividualcompany = await individualCompany({
                    data: {
                      individualID: userInfo?.individual[0]?.individualID,
                      companyID: companyData?.companyID,
                    },
                    token,
                  });
                  localStorage.removeItem("industryData");
                  localStorage.removeItem("claimComapnyID");
                  localStorage.removeItem("financialData");
                  localStorage.removeItem("companyData");
                  localStorage.removeItem("uploadData");
                  localStorage.removeItem("companyAddress");
                  localStorage.removeItem("authorizedSignatory");
                  localStorage.removeItem("claimAddressDetails");
                  localStorage.removeItem("claimAuthSignDetails");
                  localStorage.removeItem("claimContactDetails");
                  localStorage.removeItem("claimTradeLicenceDetails");
                  localStorage.removeItem("currentEditingCompany");
                  localStorage.removeItem("filledcompany");
                  localStorage.removeItem("industryDetails");
                  localStorage.removeItem("CurrentComponent");
                  localStorage.removeItem("payasyougoCompanyID");
                  localStorage.removeItem("userSelectedCompany");
                }
              } catch (error) { }
            };
            handleGetClaimed();
            setProgress(100);
            setTimeout(() => {
              onNext(createCompanyID || claimComapnyID, companyData
                ? companyData?.new_company
                : companyCurrentData?.new_company);
            }, 200);
          }
        } else {
          setApiError(authLettersUrl?.message ?? "Something went wrong")
        }
        setApiLoading(false)
      } catch (error) {
        if (error.status === 401) {
          setApiError("You are not authorized to access this page.");
        } else {
          setApiError(
            error?.data
              ? Object.values(error?.data)[0]
              : "An error occurred. Please try again later."
          );
        }
        setApiLoading(false)
      }
    }
  };

  function convertFileSize(size) {
    if (size < 1024) {
      return size + " B";
    } else if (size < 1024 * 1024) {
      return (size / 1024).toFixed(2) + " KB";
    } else {
      return (size / (1024 * 1024)).toFixed(2) + " MB";
    }
  }

  const renderPreview = () => {
    if (uploadedFile.type.includes("image")) {
      return <img src={previewImage} alt="trade" className="w-18" />;
    } else if (uploadedFile.type === "application/pdf") {
      return (
        <embed
          src={`${URL.createObjectURL(uploadedFile)}#page=1`}
          type="application/pdf"
          width="100%"
          height="500px"
        />
      );
    } else {
      return <p>Unsupported file</p>;
    }
  };
  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden pkp">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex -mx-4 xl:items-center items-center max-h-screen">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md py-20 mx-auto ">
                <h3 className=" font-heading text-f24 sm:text-f30 text-primary font-bold mb-4 text-center punitpunit">
                  Upload Authorization Letter
                </h3>
                <p className="mb-3 font-semibold text-secondary">
                  <DownloadButton
                    link={pdfLink}
                    filename={filename}
                    buttonName="Click here"
                    classes="text-primaryText pr-2"
                  />
                  to download a template
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="mb-6">
                    {!uploadedFile && (
                      <UploadingInput
                        onFileSelect={handleFileSelect}
                        isUploading={isLoading}
                      />
                    )}
                    {uploadedFile && (
                      <div className="bg-slate mt-2 p-3 rounded-md relative ">
                        <div className="flex gap-3">
                          <div
                            className={`flex-auto w-16 ${uploadedFile.type === "application/pdf"
                              ? "h-20"
                              : "h-14"
                              } overflow-hidden`}
                          >
                            {renderPreview()}
                          </div>
                          <div className="flex flex-col items-start justify-center text-secondarytwo">
                            <p className="text-f14">{uploadedFile.name}</p>
                            <div>
                              <span className="text-f12 text-secondary">
                                {convertFileSize(uploadedFile.size)}
                              </span>
                            </div>
                          </div>
                        </div>
                        {isLoading && (
                          <div className="flex gap-3 items-center justify-start mt-3">
                            <div className="bg-white h-2 rounded-full overflow-hidden  relative w-full">
                              <div
                                className="bg-primary h-full transition-all"
                                style={{ width: `${progress}%` }}
                              ></div>
                            </div>
                            <span className="">{progress}%</span>
                          </div>
                        )}

                        {uploadedFile && (
                          <button
                            className="absolute right-3 top-3"
                            onClick={() => { setUploadedFile(null); setApiError("") }}
                          >
                            <Close />
                          </button>
                        )}
                      </div>
                    )}
                    {errors.tradePhotoError && (
                      <p className="text-red-500 text-sm text-left">
                        {errors.tradePhotoError}
                      </p>
                    )}
                    {apiError && (
                      <p className="text-red-500 text-sm text-left">
                        {apiError}
                      </p>
                    )}
                  </div>
                  <div className="flex justify-between gap-2">
                    <button className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full">
                      <ArrowLeft onClick={onPrev} />
                      <span className="relative" onClick={onPrev}>
                        {" "}
                        Go Back
                      </span>
                    </button>
                    <button
                      className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${apiError || isLoading || apiError !== "" || !uploadedFile ? "cursor-not-allowed bg-disable" : "cursor-pointer bg-primary"}`}
                      type="submit"
                      disabled={isLoading || apiLoading || apiError !== "" || !uploadedFile}
                    >
                      <span className="relative">
                        {isLoading || apiLoading ? <Spinner /> : "Save & Continue"}
                      </span>
                      {!apiLoading && <ArrowRight />}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <SideSVG
              SVG={LetterSVG}
              positions="top-1/2 transform -translate-y-1/2 left-[-5%]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};